import { render } from "./table-date-start.svg?vue&type=template&id=23493c0c?inline"
const script = {}
script.render = render

export default script